import { UserAccessDifferenceValue } from "../../../../models/knowledgeBase/userAccess"

export const getRequestBody = (projectId: string, userId: string, userAccessDifference: UserAccessDifferenceValue) => ({
    ProjectId: projectId,
    OmniUserId: userId,
    OperatorId: userAccessDifference.value.Type === "Login" ? userAccessDifference.value.Value : undefined,
    RoleId: userAccessDifference.value.Type === "Role" ? userAccessDifference.value.Value : undefined
})
